import * as React from 'react';

export const MaintenanceCheckIcon = ({
  height = '14px',
  width = '14px',
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#979AB7"
      fillRule="evenodd"
      d="M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-7.96 3.964 4.336-4.367h.031V3.686L6.04 8.053 3.624 5.637v2.912l2.416 2.415Z"
      clipRule="evenodd"
    />
  </svg>
);
